import React, { useState } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import SwiperCore, { Navigation ,Thumbs, Pagination } from 'swiper'
import tractor1 from '../../images/tractor-1.jpg'
import tractor2 from '../../images/tractor-2.jpg'
import tractor3 from '../../images/tractor-3.png'
import 'swiper/swiper.scss'
import 'swiper/components/navigation/navigation.scss'


SwiperCore.use([Navigation, Thumbs, Pagination]);

const mainSwiperParams = {
    // centeredSlides: true,
    loop: false,
    // spaceBetween: 0,
    shouldSwiperUpdate: true,
    rebuildOnUpdate: true,   
}

const thumbSwiperParams = {
    spaceBetween: 10,
}




export default function ImagesGallery({ type, productId }) {
    const [thumbsSwiper, setThumbsSwiper] = useState(null);

    return (
        <div className="bg-white m-3 shadow rounded">
            <div>
                <div className="md:hidden p-2 border-b">
                    <div className="m-2">
                        <h2 className="text-xl md:text-3xl text-gray-700 tracking-wide capitalize">Massey ferguson 1035 DI</h2>
                    </div>
                    <div className="m-2 flex">
                        <span className="flex items-center bg-green-600 text-white rounded px-1 text-center">4.1<svg className="w-3 h-3" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path></svg></span>
                        <span className="ml-1 text-sm text-gray-500">10 Ratings & 4 Reviews</span>
                    </div>
                </div>
                {/* Main Slider */}
                <Swiper
                    {...mainSwiperParams}
                    thumbs={{ swiper: thumbsSwiper }}
                    slidesPerView={1}
                    navigation
                    // watchSlidesVisibility
                    // watchSlidesProgress
                    >
                    <SwiperSlide>
                        <div 
                            className="bg-contain bg-no-repeat bg-center overflow-hidden"
                            style={{backgroundImage: `url(${tractor1})`, height: "22rem"}}>
                        </div>
                    </SwiperSlide>
                    <SwiperSlide>
                        <div 
                            className="bg-contain bg-no-repeat bg-center overflow-hidden"
                            style={{backgroundImage: `url(${tractor2})`, height: "22rem"}}>
                        </div>
                    </SwiperSlide>
                    <SwiperSlide>
                        <div 
                            className="bg-contain bg-no-repeat bg-center overflow-hidden"
                            style={{backgroundImage: `url(${tractor3})`, height: "22rem"}}>
                        </div>
                    </SwiperSlide>
                    
                </Swiper>
            </div>

            <div className="hidden md:block p-2">
                {/* Thumbsnails */}
                <Swiper
                    id="gallery-thumbs"
                    {...mainSwiperParams}
                    {...thumbSwiperParams}
                    onSwiper={setThumbsSwiper}
                    // navigation={true}
                    slidesPerView={3}
                    freeMode={true}
                    watchSlidesVisibility={true}
                    watchSlidesProgress={true}
                    >
                    <SwiperSlide>
                        <div 
                            className="bg-contain bg-no-repeat bg-center h-32 p-2 overflow-hidden" 
                            style={{backgroundImage: `url(${tractor1})`}}>
                        </div>
                    </SwiperSlide>
                    <SwiperSlide>
                        <div 
                            className="bg-contain bg-no-repeat bg-center h-32 p-2 overflow-hidden" 
                            style={{backgroundImage: `url(${tractor2})`}}>
                        </div>
                    </SwiperSlide>
                    <SwiperSlide>
                        <div 
                            className="bg-contain bg-no-repeat bg-center h-32 p-2 overflow-hidden" 
                            style={{backgroundImage: `url(${tractor3})`}}>
                        </div>
                    </SwiperSlide>
                    
                </Swiper>
            </div>
        </div>
    )
}
